export const translations = {
  tr: {
    common: {
      loading: "Yükleniyor...",
      error: "Hata",
      unknownError: "Bilinmeyen hata.",
      noToken: "Token bulunamadı. Lütfen giriş yapın.",
      genericError: "Bir hata oluştu.",
      saved: "Kaydedildi.",
      pagination: {
        rowsPerPage: "Sayfa boyutu",
        prev: "Geri",
        next: "İleri",
        page: "Sayfa",
      },
      save: "Kaydet",
      cancel: "İptal",
      confirm: "Onayla",
      resetFilters: "Filtreleri temizle",
      delete: "Sil",
      edit: "Düzenle",
      back: "Geri",
      yes: "Evet",
      no: "Hayır",
      optional: "opsiyonel",
      noneSelected: "(Seçilmedi)",
      close: "Kapat",
    },
    nav: {
      general: "Genel",
      leave: "İzin",
      leaves: "İzinler",
      account: "Hesabım",
      siteSettings: "Site Ayarları",
      generalSettings: "Genel Ayarlar",
      integrationKeys: "Entegrasyon Anahtarları",
      mailSettings: "Mail Servisi",
      siteActivities: "Site Hareketleri",
      publicHolidays: "Resmi Tatiller",
      approvals: "Onay",
      organization: "Organizasyon",
      home: "Ana Sayfa",
      dashboard: "Dashboard",
      leaveRequest: "İzin Talep Et",
      myLeaves: "İzinlerim",
      leaveTypes: "İzin Türleri",
      leaveRequestsAdmin: "İzin Talepleri",
      users: "Kullanıcılar",
      teams: "Ekipler",
      team: "Ekip",
      myTeam: "Ekibim",
      teamLeaves: "Ekip İzinleri",
      fleet: "Araç Filosu",
      vehicles: "Araçlar",
      vehicleCalendar: "Araç Takvimi",
      vehicleManagement: "Araç Yönetimi",
      myReservations: "Rezervasyonlarım",
      reservationRequests: "Rezervasyon Talepleri",
      sat: "SAT Talep",
      mySat: "Taleplerim",
      satReview: "SAT Onayları",
      applications: "Başvurular",
      applicationsList: "Başvurular",
      applicationTypes: "Başvuru Tipleri",
      applicationTags: "Etiketler",
      cctv: "Ofis Kameraları",
      cctvLive: "Canlı İzleme",
    },
    cctv: {
      title: "Ofis Kameraları",
      subtitle: "Ofis kameralarını canlı izleyin. Tam ekran için bir kameraya tıklayın.",
      loading: "Kameralar yükleniyor…",
      loadError: "Kameralar yüklenemedi.",
      empty: "Görüntülenecek kamera bulunamadı.",
      expandHint: "Tam ekran için tıklayın",
      fullscreen: "Tam Ekran",
      backToGrid: "9'lu görünüm",
    },
    fleet: {
      vehiclesTitle: "Araçlar",
      vehiclesSubtitle: "Ofis araçlarını görüntüleyin ve rezerve edin.",
      viewCalendar: "Takvimi Gör",
      calendarTitle: "Araç Takvimi",
      adminVehiclesTitle: "Araç Yönetimi",
      adminVehiclesSubtitle: "Araç ekleyin, düzenleyin ve rezervasyon ayarlarını yapın.",
      adminReservationsTitle: "Rezervasyon Yönetimi",
      adminReservationsSubtitle: "Tüm rezervasyonları görüntüleyin ve onay işlemlerini yapın.",
      myReservations: "Rezervasyonlarım",
      myReservationsSubtitle: "Sahibi olduğunuz veya katılımcı olduğunuz rezervasyonlar.",
      newReservation: "Yeni Rezervasyon",
      createReservation: "Rezervasyon Oluştur",
      editReservation: "Rezervasyonu Düzenle",
      crossTeam: "başka ekip",
      crossTeamNotice:
        "Başka ekipten davet edilen kullanıcıların ekip amirlerine bildirim gönderilecek.",
      addVehicle: "Araç Ekle",
      editVehicle: "Aracı Düzenle",
      deactivate: "Pasifleştir",
      activate: "Aktifleştir",
      startsAt: "Başlangıç",
      endsAt: "Bitiş",
      reason: "Açıklama",
      reasonPlaceholder: "Nerede / hangi iş için kullanacaksınız?",
      participants: "Katılımcılar",
      searchUser: "Kullanıcı ara...",
      noUsersFound: "Eşleşen kullanıcı yok.",
      owner: "Sahibi",
      cancel: "İptal Et",
      cancelConfirm: "Rezervasyonu iptal etmek istediğinize emin misiniz?",
      approve: "Onayla",
      reject: "Reddet",
      filterByStatus: "Durum",
      all: "Tümü",
      active: "Aktif",
      inactive: "Pasif",
      name: "Ad",
      plate: "Plaka",
      image: "Görsel",
      imageHint: "JPEG, PNG veya WEBP (maks. 5 MB)",
      requireApproval: "Rezervasyonlar onay gerektirsin (company_manager onayı)",
      adminOnlyNote: "Araç ekleme ve düzenleme sadece admin rolüyle yapılabilir.",
      loadError: "Yüklenemedi.",
      noVehicles: "Henüz araç eklenmemiş.",
      noReservations: "Rezervasyon bulunamadı.",
      prevWeek: "Önceki",
      thisWeek: "Bu hafta",
      nextWeek: "Sonraki",
      days: {
        mon: "Pzt",
        tue: "Sal",
        wed: "Çar",
        thu: "Per",
        fri: "Cum",
        sat: "Cmt",
        sun: "Paz",
      },
      statuses: {
        pending: "Onay Bekliyor",
        approved: "Onaylandı",
        rejected: "Reddedildi",
        cancelled: "İptal Edildi",
      },
      errors: {
        conflict: "Seçilen zaman aralığında araç zaten rezerve edilmiş.",
        generic: "Bir hata oluştu.",
      },
    },
    account: {
      title: "Hesabım",
      profile: "Bilgilerim",
      profileSubtitle: "Profil ve izin kazanımı",
      hireDate: "İşe başlama tarihi",
      nextAccrualDate: "Sıradaki izin yenileme",
      nextAccrualDays: "Sıradaki eklenecek (gün)",
      nextAccrualTitle: "Bir sonraki izin artışı",
      nextAccrualDaysLabel: "Eklenecek gün",
      balanceTitle: "İzin bakiyesi",
      balanceSubtitle: "Toplam kalan izin durumu",
      totalLeave: "Toplam kalan izin",
      totalLeaveHours: "Toplam kalan (saatlik)",
      calendarTitle: "İzin takvimi",
      prev: "Önceki",
      next: "Sonraki",
      publicHoliday: "Resmi tatil",
      password: {
        title: "Şifre değiştir",
        manage: "Şifreyi değiştir",
        current: "Mevcut şifre",
        new: "Yeni şifre",
        new2: "Yeni şifre (tekrar)",
        save: "Kaydet",
        required: "Mevcut şifre ve yeni şifre zorunludur.",
        mismatch: "Yeni şifreler aynı değil.",
        success: "Şifre güncellendi.",
      },
    },
    holidays: {
      title: "Resmi Tatiller",
      subtitle: "Tarih araligi ekleyin, mevcutlari yonetin.",
      year: "Yil",
      addTitle: "Yeni resmi tatil",
      name: "Ad",
      namePlaceholder: "Ornek: Bayram",
      startDate: "Baslangic",
      endDate: "Bitis",
      rangeHint: "Bitis bos birakilirsa tek gun eklenir.",
      save: "Kaydet",
      saved: "Kaydedildi.",
      saveError: "Kaydetme hatasi.",
      required: "Ad ve baslangic tarihi zorunlu.",
      listTitle: "Tatil listesi",
      empty: "Kayit yok.",
      date: "Tarih",
      delete: "Sil",
    },
    settings: {
      title: "Site Ayarları",
      subtitle: "İzin kurallarını buradan yönetin.",
      leaveRequestPastDaysAllowed: "Geçmişe dönük izin talebi (gün)",
      annualLeaveSaturdayDeductionEnabled: "Yıllık izin 3+ günse cumartesi düş (1 gün fazla düşüm) kuralı aktif",
      birthdayEmailEnabled: "Doğum günü kutlama e-postaları aktif",
      minLeaveDeductDays: "Minimum izin düşüm birimi (gün)",
      minLeaveDeductDaysHint: "Günlük (bakiye düşen) izinlerde süre bu değerin katı olmalıdır. 0.5 seçilirse yarım gün izin kullanılabilir.",
      minNegativeLeaveBalanceDays: "Minimum izin bakiyesi (gün)",
      minNegativeLeaveBalanceDaysHint: "Günlük (bakiye düşen) izinlerde bakiye bu değerin altına inemez. Örn: -20 girilirse -20 güne kadar düşebilir.",
      userTotalLeaveQuotaMin: "Kullanıcı kalan izin minimum (gün)",
      userTotalLeaveQuotaMinHint: "Admin, kullanıcı oluşturma/düzenleme ekranında kalan yıllık izin gün sayısını bu değerin altına indiremez. Örn: -14 girilirse en düşük -14 gün olabilir.",
      travelDailyAmountTry: "Yurtiçi günlük harcırah (TL)",
      travelDailyAmountTryHint: "Görev/Seyahat izninde yurtiçi seyahatler için kullanılacak günlük harcırah tutarı. İzin oluşturulduğu an forma snapshot olarak yapışır.",
      travelDailyAmountEur: "Yurtdışı günlük harcırah (EUR)",
      travelDailyAmountEurHint: "Görev/Seyahat izninde yurtdışı seyahatler için kullanılacak günlük harcırah tutarı (EUR). Snapshot olarak forma yapışır.",
      reload: "Yenile",
      loadError: "Ayarlar alınamadı.",
      saveError: "Ayarlar kaydedilemedi.",
    },
    topbar: {
      notifications: "Bildirimler",
      logout: "Çıkış",
      account: "Hesap",
      noNotifications: "Yeni bildiriminiz yok.",
      deleteNotification: "Bildirimi Sil",
      openMenu: "Menüyü aç",
      closeMenu: "Menüyü kapat",
      theme: "Tema",
      language: "Dil",
      light: "Açık",
      dark: "Koyu",
      tr: "TR",
      en: "EN",
    },
    auth: {
      email: "E-posta",
      password: "Şifre",
      login: "Giriş Yap",
      loggingIn: "Giriş Yapılıyor...",
      title: "Giriş yap",
      subtitle: "Hesabınla giriş yaparak izin süreçlerini hızlıca yönet.",
      logoAlt: "Giriş sayfası logosu",
      forgotPassword: {
        link: "Şifremi unuttum",
        title: "Şifremi unuttum",
        subtitle: "E-posta adresini gir, şifre sıfırlama bağlantısı gönderelim.",
        submit: "Sıfırlama bağlantısı gönder",
        sent: "Parola sıfırlama bağlantısı e-posta adresinize gönderildiyse, lütfen gelen kutunuzu kontrol edin.",
        backToLogin: "Giriş ekranına dön",
      },
      resetPassword: {
        title: "Şifreyi sıfırla",
        subtitle: "Yeni şifreni belirle ve hesabına tekrar giriş yap.",
        submit: "Şifreyi güncelle",
        mismatch: "Yeni şifreler aynı değil.",
        success: "Parola başarıyla sıfırlandı.",
      },
    },
    dashboard: {
      welcome: "Hoş geldiniz, {{name}}!",
      leaveBalance: "İzin Bakiyeniz",
      recentLeaves: "Son İzinleriniz",
      stats: "İzin İstatistikleri",
      loadingData: "Veriler yükleniyor...",
      annualNotFound: "Yıllık izin bilgisi bulunamadı.",
      noLeaves: "Henüz bir izin kaydınız bulunmamaktadır.",
      totalRequests: "Toplam İzin Talebi",
      approved: "Onaylanan",
      rejected: "Reddedilen",
      pending: "Beklemede",
    },
    leave: {
      createTitle: "İzin Oluştur",
      createEyebrow: "Yeni izin talebi",
      createLede:
        "Talep otomatik olarak bağlı olduğun yönetici → şirket yöneticisi → HR sırası ile ilerleyecek. Başlangıç/bitiş değerleri bugüne ayarlı, gerekirse güncelle.",
      historyCta: "İzin geçmişim",
      successCreated: "İzin başarıyla oluşturuldu!",
      myTitle: "İzin Taleplerim",
      myEyebrow: "İzin yaşam döngüsü",
      myLede:
        "Tüm taleplerinin hangi aşamada olduğunu gör, geçmiş kayıtlarını kontrol et. Yeni talep için aşağıdaki butonu kullan.",
      myEmpty: "Henüz bir izin talebiniz yok.",
      newRequest: "Yeni izin oluştur",
      cancelConfirm: "Bu izin talebini iptal etmek istediğinize emin misiniz?",
      cancelSuccess: "İzin talebi başarıyla iptal edildi.",
      subTypesLoadFailed: "Alt izin türleri yüklenirken bir hata oluştu.",
      overallStatus: "Genel Durum",
      nextStage: "Sıradaki",
      stage: {
        unitSupervisor: "Birim Amiri",
        companyManager: "Şirket Yöneticisi",
        hr: "HR",
      },
      fields: {
        start: "Başlangıç",
        end: "Bitiş",
        reasonMissing: "Açıklama yok",
      },
      actions: {
        update: "Güncelle",
        cancel: "İptal Et",
        none: "İşlem Yok",
      },
      edit: {
        modalTitle: "İzin Güncelle",
        required: "Lütfen tüm zorunlu alanları doldurun: İzin Türü, Başlangıç Tarihi, Açıklama.",
        timeRequired: "Saat gerektiren izinlerde başlangıç ve bitiş saati zorunludur.",
        endDateRequired: "Günlük izinler için bitiş tarihi zorunludur.",
        authError: "Kimlik doğrulama hatası. Lütfen tekrar giriş yapın.",
        startTimeAfter: "Başlangıç saati bitiş saatinden sonra olamaz.",
        hoursPositive: "Hesaplanan izin süresi (saat) pozitif bir değer olmalıdır.",
        startAfterEnd: "Başlangıç tarihi bitiş tarihinden sonra olamaz.",
        businessDaysPositive:
          "Hesaplanan izin süresi pozitif bir iş günü olmalıdır (Hafta sonları hariç).",
        updateSuccess: "İzin başarıyla güncellendi!",
        resubmittedSuccess: "İzin güncellendi ve tekrar onaya gönderildi.",
        updateErrorPrefix: "İzin güncellenirken bir hata oluştu: ",
      },
      form: {
        leaveType: "İzin Türü",
        leaveTypeSelect: "İzin Türü Seçiniz",
        subType: "Mazeret İzni Alt Türü",
        select: "Seçiniz",
        startDate: "Başlangıç Tarihi",
        endDate: "Bitiş Tarihi",
        startTime: "Başlangıç Saati",
        endTime: "Bitiş Saati",
        reason: "Açıklama",
        reasonPlaceholder: "İzin açıklamanızı giriniz...",
        reportPdfLabel: "Rapor (PDF) - opsiyonel",
        reportPdfLabelShort: "Rapor PDF",
        reportPdfHint: "İstersen raporunu PDF olarak yükleyebilirsin.",
        reportPdfSelected: "Seçilen dosya",
        reportPdfOnlyPdf: "Lütfen sadece PDF yükleyin.",
        reportPdfTooLarge: "PDF dosyası maksimum 10MB olmalıdır.",
        reportPdfUploadFailed: "Rapor PDF yüklenemedi.",
        submit: "İzin Talebi Gönder",
        calculating: "Hesaplanıyor...",
        publicHolidays: "Resmi tatiller",
        publicHolidaysNotice: "Bu günler izin düşümüne dahil edilmez.",
        back: "Geri",
        next: "İleri",
        confirm: "Onayla ve gönder",
        steps: {
          type: "İzin türü",
          date: "Tarih",
          reason: "Açıklama",
          review: "Özet",
        },
        errors: {
          requiredFields: "Lütfen tüm zorunlu alanları doldurun.",
          genderFetchFailed: "Kullanıcı cinsiyeti alınamadı.",
          loadFailed: "Gerekli veriler yüklenirken bir hata oluştu.",
          subTypeRequired: "Mazeret izni için alt tür seçimi zorunludur.",
          timeRequired: "Lütfen başlangıç ve bitiş saatlerini seçin.",
          endDateRequired: "Bitiş tarihi zorunludur.",
          hourlyLimit: "Saatlik izin süresi 0 olamaz ve maksimum {{max}} geçemez.",
        },
        warnings: {
          startTimeMin: "İzin başlangıç saati 08:00'dan önce olamaz.",
          endTimeMax: "İzin bitiş saati 18:00'dan sonra olamaz.",
          timeRangeInvalid:
            "Seçilen saat aralığı (öğle arası düşüldükten sonra) sıfır veya negatif olamaz. Lütfen farklı bir aralık seçin.",
          maxDuration: "İzin süresi maksimum {{max}} geçemez. Seçilen süre: {{selected}}",
        },
      },
      summary: {
        title: "İzin Özeti",
        annualTitle: "Yıllık İzin Özeti",
        unpaidTitle: "Ücretsiz İzin Özeti",
        travelTitle: "Görev/Seyahat İzni Özeti",
        hourlyTitle: "Saatlik İzin Özeti",
        excuseTitle: "Mazeret İzni Özeti",
        currentAnnualBalance: "Mevcut Yıllık İzin Bakiyesi",
        requestedDuration: "Talep Edilen İzin Süresi",
        returnTime: "İşe Dönüş Saati",
        returnDate: "İşe Dönüş Tarihi",
        remainingAfter: "İzin Sonrası Kalan Bakiye",
        businessDays: "iş günü",
        hours: "saat",
        days: "gün",
      },
      document: {
        ref: "Doküman Ref",
        download: "Çıktı Al (PDF)",
        downloadShort: "PDF",
        previewShort: "Önizle",
        openNewTab: "Sekmede aç",
      },
      reportPdf: {
        title: "Rapor PDF",
        badge: "Rapor",
        previewShort: "Rapor Önizle",
        downloadShort: "Rapor İndir",
      },
      status: {
        pending: "Beklemede",
        approved: "Onaylandı",
        rejected: "Reddedildi",
        skipped: "Atlandı",
        cancelled: "İptal Edildi",
      },
    },
    admin: {
      dashboard: {
        title: "Admin Paneli",
        statsTitle: "Genel İzin İstatistikleri",
        pendingTitle: "Onay Bekleyen İzinler",
        pendingEmpty: "Onay bekleyen izin talebi bulunmamaktadır.",
      },
      users: {
        title: "Kullanıcılar",
        newUser: "Yeni Kullanıcı",
        deleteConfirm: "Kullanıcı silinsin mi?",
        active: "Aktif",
        totalLeave: "Kalan izin",
	        totalLeaveDays: "Kalan izin (gün)",
	        import: {
	          title: "Toplu Kullanıcı Ekle (Excel .xlsx)",
	          downloadTemplate: "Örnek Excel (.xlsx) indir",
	          exportButton: "Kullanıcıları dışa aktar (.xlsx)",
	          chooseFile: "Dosya seç",
	          importButton: "İçe Aktar",
	          help: "Excel (.xlsx) dosyası yükleyin. İlk satır başlık olmalı.",
	          resultTitle: "İçe aktarma sonucu",
	          created: "Eklenen",
	          skipped: "Atlanan",
	          failed: "Hatalı",
	          warnings: "Uyarı",
	          passwordNote: "Şifre boş bırakılırsa sistem üretir ve sadece bu ekranda gösterilir.",
	        },
        fields: {
          name: "Ad",
          surname: "Soyad",
          email: "Email",
          username: "Kullanıcı adı",
          role: "Rol",
          team: "Ekip",
          manager: "Birim amiri",
          department: "Departman",
          section: "Bölüm",
          title: "Ünvan",
          gender: "Cinsiyet",
          registryNumber: "Sicil No",
          birthDate: "Doğum tarihi",
          leaveBaseDate: "İşe başlama tarihi",
          leaveAccrualStartDate: "Sıradaki izin yenileme",
          nextAccrualEntitlementDays: "Sıradaki eklenecek (gün)",
          password: "Şifre",
          passwordOptional: "Şifre (opsiyonel)",
        },
        editTitle: "Kullanıcı Düzenle: {{username}}",
      },
      teams: {
        title: "Ekipler",
        namePlaceholder: "Ekip adı",
        managerPlaceholder: "(Ekip yöneticisi seç)",
        add: "Ekle",
        deleteConfirm: "Ekip silinsin mi?",
        columns: { name: "Ad", manager: "Yönetici" },
      },
      leaves: {
        title: "İzin Talepleri",
        empty: "Henüz görüntülenecek bir izin talebi yok.",
        approve: "Onayla",
        reject: "Reddet",
        requestEdit: "Düzenleme Talebi",
        sendEditRequest: "Talebi Gönder",
        approveEdit: "Düzenlemeyi Onayla",
        rejectEdit: "Düzenlemeyi Reddet",
        editRequested: "Düzenleme talebi company manager onayına gönderildi.",
        editApproved: "Düzenleme onaylandı ve uygulandı.",
        editRejected: "Düzenleme talebi reddedildi.",
        noAction: "İşlem yok",
        columns: {
          requester: "Personel",
          type: "İzin türü",
          duration: "Süre",
          actions: "İşlemler",
        },
        start: "Başlangıç",
        end: "Bitiş",
        balance: "Bakiyesi",
        balanceNotAffected: "Bakiye etkilenmez",
        missingInfo: "Bilgi Eksik",
        loadErrorPrefix: "İzinler yüklenirken bir hata oluştu: ",
        updateErrorPrefix: "İzin durumu güncellenirken bir hata oluştu: ",
        rejectPrompt: "Red sebebi (opsiyonel)",
        rejectTitle: "İzin talebini reddet",
        hrCancel: "İznı İptal Et",
        hrCancelTitle: "Onaylı İzni İptal Et",
        hrCancelIntro:
          "{{person}} kullanıcısının {{type}} iznini ({{start}} → {{end}}) iptal etmek üzeresiniz.",
        hrCancelRestoreBalance: "Düşülen bakiyeyi kullanıcıya geri ekle",
        hrCancelReasonLabel: "İptal sebebi (opsiyonel)",
        hrCancelReasonPlaceholder: "İptal sebebi…",
        hrCancelConfirm: "İptal Et",
        hrCancelSuccess: "İzin iptal edildi.",
        hrCancelSuccessRestored: "İzin iptal edildi ve bakiye geri eklendi.",
        code: "Kod",
        balanceBefore: "Öncesi",
        balanceAfter: "Sonrası",
        createdAt: "Oluşturulma",
        details: "Detay",
        detailsTitle: "İzin Detayı",
        notLoaded: "Detaylar yüklenemedi.",
        sectionRequester: "Talep Sahibi",
        sectionLeave: "İzin Bilgileri",
        sectionApproval: "Onay Akışı",
        sectionTravel: "Görev / Seyahat Detayları",
        sectionPerDiem: "Harcırah",
        sectionExpenses: "Ek Harcamalar",
        proxyUser: "Vekalet veren",
        reasonLabel: "Açıklama",
        excuseLabel: "Mazeret Detayı",
        travelDestination: "Gidilecek yer",
        travelProject: "Proje",
        travelDays: "Görev süresi (gün)",
        documentationUrl: "Belge bağlantısı",
        tripType: "Yolculuk türü",
        tabs: { mine: "Sırası bende", pending: "Onay bekleyen", approved: "Onaylanan", closed: "Reddedilen / İptal", all: "Tümü" },
        filters: {
          search: "Ad, soyad veya talep kodu ara...",
          allTypes: "Tüm izin türleri",
          from: "Başlangıç ≥",
          to: "Bitiş ≤",
          sort: "Sırala",
          sortCreatedDesc: "Talep tarihi (yeni → eski)",
          sortCreatedAsc: "Talep tarihi (eski → yeni)",
          sortStartAsc: "İzin başlangıcı (yakın → uzak)",
          sortStartDesc: "İzin başlangıcı (uzak → yakın)",
          reset: "Filtreleri temizle",
        },
        emptyFiltered: "Bu görünümde kayıt yok.",
        approvalChain: "Onay süreci",
        waitingDays: "gündür bekliyor",
        tripDomestic: "Yurt içi",
        tripInternational: "Yurt dışı",
        tripIntracity: "Şehir içi (harcırahsız)",
        transport: "Ulaşım",
        accommodation: "Konaklama",
        perDiemDaily: "Günlük harcırah",
        perDiemDays: "Gün sayısı",
        perDiemTotal: "Toplam harcırah",
        perDiemSave: "Kaydet",
        perDiemSaving: "Kaydediliyor…",
        perDiemUpdated: "Harcırah bedeli güncellendi.",
        perDiemUpdateFailed: "Harcırah bedeli güncellenemedi.",
        perDiemInvalid: "Günlük harcırah bedeli geçerli değil.",
        expensePayee: "Şirket / Tedarikçi",
        expenseDate: "Tarih",
        expenseInvoice: "Fatura bedeli",
        expenseLimit: "Limit",
        expensePayable: "Ödenecek",
        expenseDescription: "Açıklama",
        expenseReceipt: "Fiş",
        expenseReceiptYes: "Var",
        expenseReceiptNo: "Yok",
        expenseReceiptUpload: "Yükle",
        expenseReceiptReplace: "Değiştir",
        expenseReceiptDownload: "İndir",
        expenseReceiptUploading: "Yükleniyor…",
        expenseReceiptOnlyPdf: "Lütfen sadece PDF yükleyin.",
        expenseReceiptTooLarge: "PDF dosyası maksimum 10MB olmalıdır.",
        expenseReceiptUploaded: "Fiş yüklendi.",
        expenseReceiptUploadFailed: "Fiş yüklenemedi.",
        expenseReceiptDownloadFailed: "Fiş indirilemedi.",
      },
      siteActivities: {
        title: "Site Hareketleri",
        subtitle: "Son 6 ay içindeki kullanıcı ve sistem hareketlerini filtreleyerek görüntüleyin.",
        empty: "Bu filtrelerle gösterilecek hareket bulunamadı.",
        filters: {
          from: "Başlangıç",
          to: "Bitiş",
          user: "Kullanıcı",
          action: "Aksiyon",
          entity: "Kayıt türü",
          outcome: "Sonuç",
          search: "Arama",
          searchPlaceholder: "Kullanıcı, aksiyon veya yol ara",
          allUsers: "Tüm kullanıcılar",
          allActions: "Tüm aksiyonlar",
          allEntities: "Tüm kayıt türleri",
          allOutcomes: "Tüm sonuçlar",
          apply: "Filtrele",
          reset: "Varsayılan 7 güne dön",
        },
        columns: {
          date: "Tarih",
          user: "Kullanıcı",
          action: "Aksiyon",
          entity: "Kayıt",
          detail: "Detay",
          outcome: "Sonuç",
        },
      },
    },
    team: {
      eyebrow: "Ekip görünümü",
      title: "Ekibim",
      subtitle: "Bağlı personel ve temel bilgileri.",
      refresh: "Yenile",
      empty: "Bağlı personel bulunamadı.",
      calendarTitle: "İzin takvimi",
      calendarScopeCompany: "Şirket genelindeki onaylı izinler",
      calendarScopeUnit: "Birimimdeki onaylı izinler",
      calendarApprovedLegend: "Onaylı izin",
      calendarOffCount: "{{count}} kişi izinli",
      upcomingApprovedTitle: "Yaklaşan onaylı izinler",
      upcomingInDays: "Başlamasına",
      inDays: "{{days}} gün",
      columns: {
        name: "Ad Soyad",
        username: "Kullanıcı",
        role: "Rol",
        team: "Ekip",
        department: "Departman/Bölüm",
        manager: "Yönetici",
        annualLeaveBalance: "Yıllık İzin Bakiyesi",
      },
      roles: {
        companyManager: "Şirket Yöneticisi",
        hr: "HR",
        unitSupervisor: "Birim Amiri",
        employee: "Çalışan",
        it: "IT",
      },
    },
    teamLeaves: {
      eyebrow: "Ekip izin geçmişi",
      title: "Ekip İzinleri",
      subtitle: "Bağlı ekibinizin izin geçmişini ve durumlarını görüntüleyin.",
      refresh: "Yenile",
      export: "İzin dökümü indir",
      filters: {
        user: "Personel",
        status: "Durum",
        allUsers: "Tüm kişiler",
        allStatuses: "Tüm durumlar",
        includeRejected: "Reddedilenleri dahil et",
      },
      columns: {
        person: "Personel",
        username: "Kullanıcı",
        team: "Ekip",
        type: "İzin",
        start: "Başlangıç",
        end: "Bitiş",
        duration: "Süre",
        status: "Durum",
        stage: "Aşama",
      },
      empty: "Gösterilecek izin bulunamadı.",
    },
    leaveTypes: {
      title: "İzin Türleri",
      loadError: "İzin türleri alınamadı.",
      empty: "Henüz tanımlı izin türü yok.",
      newType: "Yeni izin türü",
      editType: "İzin türünü düzenle",
      confirmDelete: "İzin türü silinsin mi?",
      defaultQuotaDays: "Varsayılan kota (gün)",
      defaultQuotaHours: "Varsayılan kota (saat)",
      columns: {
        name: "Ad",
        description: "Açıklama",
        affectsBalance: "Bakiye Etkiler",
        type: "Tip",
        defaultDuration: "Varsayılan Süre",
      },
      duration: {
        hourly: "Saatlik",
        daily: "Günlük",
      },
    },
    satRequest: {
      title: "SAT Talepleri",
      subtitle: "Satın alma taleplerini oluşturun ve takip edin.",
      newRequest: "Yeni Talep",
      fields: {
        code: "Talep Kodu",
        title: "Başlık",
        description: "Açıklama",
        category: "Kategori",
        priority: "Öncelik",
        itemUrl: "Ürün Linki",
        itemUrlPlaceholder: "https://...",
        quantity: "Adet",
        unitPrice: "Birim Fiyat (TL)",
        totalPrice: "Toplam",
        needsItReview: "IT ürün alternatiflerine baksın",
        needsItReviewHint:
          "İşaretlerseniz talep, birim amiri onayından sonra IT incelemesine uğrar. İşaretlenmezse IT adımı atlanır.",
        createdBy: "Oluşturan",
        assignee: "Atanan IT",
        createdAt: "Oluşturma",
        status: "Durum",
        note: "Not",
        notePlaceholder: "İsteğe bağlı açıklama",
        reason: "Red Sebebi",
        reasonPlaceholder: "Redde gerekçe (en az 10 karakter)",
        invoiceUrl: "Fatura Linki",
        invoiceUrlPlaceholder: "https://... (irsaliye/fatura PDF veya görseli)",
        invoiceFile: "Fatura Dosyası",
        actualPrice: "Gerçekleşen Birim Fiyat (TL)",
        actualTotal: "Gerçekleşen Toplam",
        department: "Departman",
        total: "Toplam",
      },
      category: {
        unit_need: "Birim / İş İhtiyacı",
        it_need: "IT İhtiyacı",
        office_supplies: "Ofis Malzemesi",
        general_supplies: "Genel Malzeme",
        // geriye donuk uyumluluk: eski kayitlar varsa label kalsin
        hardware: "Donanım",
        software: "Yazılım",
        access: "Erişim / Lisans",
        other: "Diğer",
      },
      priority: {
        low: "Düşük",
        medium: "Orta",
        high: "Yüksek",
      },
      status: {
        pending_supervisor: "Birim Amiri Onayı Bekliyor",
        pending_it: "IT İncelemesi Bekliyor",
        pending_manager: "Yönetici Onayı Bekliyor",
        pending_hr: "IK Tamamlaması Bekliyor",
        completed: "Tamamlandı",
        rejected: "Reddedildi",
        cancelled: "İptal Edildi",
      },
      actions: {
        supervisorApprove: "Birim Amiri Onayla",
        supervisorReject: "Birim Amiri Reddet",
        itApprove: "IT Onayla",
        itReject: "IT Reddet",
        managerApprove: "Yönetici Onayla",
        managerReject: "Yönetici Reddet",
        hrComplete: "IK Tamamla",
        hrReject: "IK Reddet",
        cancel: "İptal Et",
      },
      tabs: {
        supervisor: "Birim Amiri Onayı",
        it: "IT İncelemesi",
        manager: "Yönetici Onayı",
        hr: "IK İşleme",
        completed: "Tamamlananlar",
        all: "Tümü",
      },
      empty: "Henüz talep yok.",
      myEmpty: "Henüz talep oluşturmadınız.",
      timeline: {
        created: "Talep oluşturuldu",
        supervisor_approved: "Birim amiri onayladı",
        supervisor_rejected: "Birim amiri reddetti",
        it_edited: "IT talep alanlarını düzenledi",
        it_approved: "IT onayladı",
        it_rejected: "IT reddetti",
        manager_approved: "Yönetici onayladı",
        manager_rejected: "Yönetici reddetti",
        hr_rejected: "IK reddetti",
        completed: "IK tamamladı",
        cancelled: "İptal edildi",
        claimed: "Alındı",
        released: "Bırakıldı",
        proforma_uploaded: "Sipariş teklifi yüklendi",
        invoice_uploaded: "Fatura yüklendi",
      },
      docs: {
        title: "Belgeler (her aşamada eklenebilir)",
        proforma: "Sipariş teklifi (PDF/JPG/PNG)",
        invoice: "Fatura (PDF/JPG/PNG)",
        hint: "İsteğe bağlı. Yeni dosya yüklerseniz öncekinin yerini alır (en fazla 10MB).",
      },
      confirmCancel: "Talebinizi iptal etmek istediğinizden emin misiniz?",
      confirmRelease: "Talebi havuza geri vermek istediğinize emin misiniz?",
      validation: {
        titleLen: "Başlık 3-200 karakter olmalı.",
        descriptionLen: "Açıklama en az 10 karakter olmalı.",
        urlInvalid: "Geçerli bir http/https linki girin.",
        quantityMin: "Adet en az 1 olmalı.",
        unitPriceMin: "Birim fiyat 0 veya üzeri olmalı.",
        invoiceUrlInvalid: "Geçerli bir fatura linki (http/https) girin.",
        fileRequired: "Bir fatura dosyası seçin.",
        fileTooLarge: "Dosya boyutu 10 MB'yi aşamaz.",
        actualPriceMin: "Gerçekleşen bedel 0 veya üzeri olmalı.",
      },
      completeModal: {
        title: "Talebi Tamamla",
        hint: "Fatura linki ve gerçekleşen birim fiyatı girin. Plan ile fark karşılaştırılacak.",
      },
      exportXlsx: "Excel'e aktar",
      departmentReport: "Departman Raporu",
      teamReport: "Ekip Raporu",
      groupBy: "Grupla",
      groupByDepartment: "Departman",
      groupByTeam: "Ekip",
      teamLabel: "Ekip",
      teamUnknown: "(takımsız)",
      dateFrom: "Başlangıç",
      dateTo: "Bitiş",
      apply: "Uygula",
      clear: "Temizle",
      proformaFile: "Teklif / Proforma Dosyası",
      proformaFileHint: "İsteğe bağlı: PDF, JPG veya PNG (en fazla 10MB).",
      proformaDownload: "Teklif / proformayı indir",
      invoiceDownload: "Faturayı indir",
      noProforma: "Teklif / proforma yüklenmemiş.",
      itemUrlOptionalHint: "Ürün linki opsiyoneldir; teklif/proforma yüklendiyse boş bırakabilirsiniz.",
      widget: {
        myOpen: "Açık taleplerim",
        awaitingSupervisor: "Birim amiri onayı",
        awaitingIt: "IT incelemesi",
        awaitingManager: "Yönetici onayı",
        awaitingHr: "IK tamamlaması",
      },
    },
  },
  en: {
    common: {
      loading: "Loading...",
      error: "Error",
      unknownError: "Unknown error.",
      noToken: "Token not found. Please sign in.",
      genericError: "Something went wrong.",
      saved: "Saved.",
      pagination: {
        rowsPerPage: "Rows",
        prev: "Prev",
        next: "Next",
        page: "Page",
      },
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      resetFilters: "Clear filters",
      delete: "Delete",
      edit: "Edit",
      back: "Back",
      yes: "Yes",
      no: "No",
      optional: "optional",
      noneSelected: "(None)",
      close: "Close",
    },
    nav: {
      general: "General",
      leave: "Leave",
      leaves: "Leaves",
      account: "My Account",
      siteSettings: "Site Settings",
      generalSettings: "General Settings",
      integrationKeys: "Integration Keys",
      mailSettings: "Mail Service",
      siteActivities: "Site Activity",
      publicHolidays: "Public Holidays",
      approvals: "Approvals",
      organization: "Organization",
      home: "Home",
      dashboard: "Dashboard",
      leaveRequest: "Request Leave",
      myLeaves: "My Leaves",
      leaveTypes: "Leave Types",
      leaveRequestsAdmin: "Leave Requests",
      users: "Users",
      teams: "Teams",
      team: "Team",
      myTeam: "My Team",
      teamLeaves: "Team Leaves",
      fleet: "Fleet",
      vehicles: "Vehicles",
      vehicleCalendar: "Vehicle Calendar",
      vehicleManagement: "Vehicle Management",
      myReservations: "My Reservations",
      reservationRequests: "Reservation Requests",
      sat: "Purchase Requests",
      mySat: "My Requests",
      satReview: "Purchase Approvals",
      applications: "Applications",
      applicationsList: "Applications",
      applicationTypes: "Application Types",
      applicationTags: "Tags",
      cctv: "Office Cameras",
      cctvLive: "Live View",
    },
    cctv: {
      title: "Office Cameras",
      subtitle: "Watch office cameras live. Click a camera for fullscreen.",
      loading: "Loading cameras…",
      loadError: "Failed to load cameras.",
      empty: "No cameras available.",
      expandHint: "Click for fullscreen",
      fullscreen: "Fullscreen",
      backToGrid: "Grid view",
    },
    fleet: {
      vehiclesTitle: "Vehicles",
      vehiclesSubtitle: "Browse office vehicles and book them.",
      viewCalendar: "View Calendar",
      calendarTitle: "Vehicle Calendar",
      adminVehiclesTitle: "Vehicle Management",
      adminVehiclesSubtitle: "Add or edit vehicles and manage reservation settings.",
      adminReservationsTitle: "Reservation Management",
      adminReservationsSubtitle: "View all reservations and approve/reject requests.",
      myReservations: "My Reservations",
      myReservationsSubtitle: "Reservations you own or are a participant in.",
      newReservation: "New Reservation",
      createReservation: "Create Reservation",
      editReservation: "Edit Reservation",
      crossTeam: "other team",
      crossTeamNotice:
        "A notification will be sent to the team supervisor of participants from other teams.",
      addVehicle: "Add Vehicle",
      editVehicle: "Edit Vehicle",
      deactivate: "Deactivate",
      activate: "Activate",
      startsAt: "Starts at",
      endsAt: "Ends at",
      reason: "Reason",
      reasonPlaceholder: "Where / what will you use it for?",
      participants: "Participants",
      searchUser: "Search user...",
      noUsersFound: "No matching user.",
      owner: "Owner",
      cancel: "Cancel",
      cancelConfirm: "Are you sure you want to cancel this reservation?",
      approve: "Approve",
      reject: "Reject",
      filterByStatus: "Status",
      all: "All",
      active: "Active",
      inactive: "Inactive",
      name: "Name",
      plate: "Plate",
      image: "Image",
      imageHint: "JPEG, PNG or WEBP (max 5 MB)",
      requireApproval: "Reservations require approval (company_manager)",
      adminOnlyNote: "Adding or editing vehicles is available to admin role only.",
      loadError: "Failed to load.",
      noVehicles: "No vehicles yet.",
      noReservations: "No reservations.",
      prevWeek: "Prev",
      thisWeek: "This week",
      nextWeek: "Next",
      days: {
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat",
        sun: "Sun",
      },
      statuses: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        cancelled: "Cancelled",
      },
      errors: {
        conflict: "The selected time range is already booked.",
        generic: "Something went wrong.",
      },
    },
    account: {
      title: "My Account",
      profile: "Profile",
      profileSubtitle: "Profile and accruals",
      hireDate: "Hire date",
      nextAccrualDate: "Next accrual date",
      nextAccrualDays: "Next accrual (days)",
      nextAccrualTitle: "Next accrual",
      nextAccrualDaysLabel: "Days to add",
      balanceTitle: "Leave balance",
      balanceSubtitle: "Total remaining leave",
      totalLeave: "Total remaining (days)",
      totalLeaveHours: "Total remaining (hours)",
      calendarTitle: "Leave calendar",
      prev: "Prev",
      next: "Next",
      publicHoliday: "Public holiday",
      password: {
        title: "Change password",
        manage: "Change password",
        current: "Current password",
        new: "New password",
        new2: "New password (again)",
        save: "Save",
        required: "Current password and new password are required.",
        mismatch: "New passwords do not match.",
        success: "Password updated.",
      },
    },
    holidays: {
      title: "Public holidays",
      subtitle: "Add date ranges and manage entries.",
      year: "Year",
      addTitle: "Add holiday",
      name: "Name",
      namePlaceholder: "Example: Holiday",
      startDate: "Start date",
      endDate: "End date",
      rangeHint: "If end date is empty, only one day is added.",
      save: "Save",
      saved: "Saved.",
      saveError: "Save failed.",
      required: "Name and start date are required.",
      listTitle: "Holiday list",
      empty: "No records.",
      date: "Date",
      delete: "Delete",
    },
    settings: {
      title: "Site Settings",
      subtitle: "Manage leave rules here.",
      leaveRequestPastDaysAllowed: "Backdated leave request (days)",
      annualLeaveSaturdayDeductionEnabled: "Extra 1-day deduction rule enabled (annual leave 3+ days)",
      birthdayEmailEnabled: "Birthday celebration emails enabled",
      minLeaveDeductDays: "Minimum leave deduction unit (days)",
      minLeaveDeductDaysHint: "For day-based (balance-deducting) leaves, duration must be a multiple of this value. Set 0.5 to allow half-day leave.",
      minNegativeLeaveBalanceDays: "Minimum leave balance (days)",
      minNegativeLeaveBalanceDaysHint: "For day-based (balance-deducting) leaves, balance cannot go below this value. Example: -20 allows going down to -20 days.",
      userTotalLeaveQuotaMin: "User remaining leave minimum (days)",
      userTotalLeaveQuotaMinHint: "When an admin creates/edits a user, the remaining annual leave cannot be set below this value. Example: -14 allows going down to -14 days.",
      travelDailyAmountTry: "Domestic per-diem (TRY/day)",
      travelDailyAmountTryHint: "Per-diem daily amount used for domestic travel in Business Travel leaves. Snapshotted to the form at creation time.",
      travelDailyAmountEur: "International per-diem (EUR/day)",
      travelDailyAmountEurHint: "Per-diem daily amount used for international travel (EUR). Snapshotted to the form at creation time.",
      reload: "Reload",
      loadError: "Failed to load settings.",
      saveError: "Failed to save settings.",
    },
    topbar: {
      notifications: "Notifications",
      logout: "Logout",
      account: "Account",
      noNotifications: "No new notifications.",
      deleteNotification: "Delete notification",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      theme: "Theme",
      language: "Language",
      light: "Light",
      dark: "Dark",
      tr: "TR",
      en: "EN",
    },
    auth: {
      email: "Email",
      password: "Password",
      login: "Sign In",
      loggingIn: "Signing in...",
      title: "Sign in",
      subtitle: "Sign in to quickly manage your leave requests and approvals.",
      logoAlt: "Login logo",
      forgotPassword: {
        link: "Forgot password?",
        title: "Forgot password",
        subtitle: "Enter your email and we'll send a password reset link.",
        submit: "Send reset link",
        sent: "If a password reset link was sent to your email address, please check your inbox.",
        backToLogin: "Back to login",
      },
      resetPassword: {
        title: "Reset password",
        subtitle: "Set a new password and sign in again.",
        submit: "Update password",
        mismatch: "New passwords do not match.",
        success: "Password has been reset successfully.",
      },
    },
    dashboard: {
      welcome: "Welcome, {{name}}!",
      leaveBalance: "Your Leave Balance",
      recentLeaves: "Recent Leaves",
      stats: "Leave Statistics",
      loadingData: "Loading data...",
      annualNotFound: "Annual leave info not found.",
      noLeaves: "You don't have any leave records yet.",
      totalRequests: "Total Requests",
      approved: "Approved",
      rejected: "Rejected",
      pending: "Pending",
    },
    leave: {
      createTitle: "Create Leave",
      createEyebrow: "New leave request",
      createLede:
        "Your request will automatically follow Unit Supervisor → Company Manager → HR. Start/end values default to today; adjust if needed.",
      historyCta: "My leave history",
      successCreated: "Leave request created successfully!",
      myTitle: "My Leave Requests",
      myEyebrow: "Leave lifecycle",
      myLede:
        "See which stage your requests are in and review past records. Use the button below to create a new request.",
      myEmpty: "You don't have any leave requests yet.",
      newRequest: "Create new leave",
      cancelConfirm: "Are you sure you want to cancel this leave request?",
      cancelSuccess: "Leave request cancelled successfully.",
      subTypesLoadFailed: "Failed to load leave sub-types.",
      overallStatus: "Overall Status",
      nextStage: "Next",
      stage: {
        unitSupervisor: "Unit Supervisor",
        companyManager: "Company Manager",
        hr: "HR",
      },
      fields: {
        start: "Start",
        end: "End",
        reasonMissing: "No description",
      },
      actions: {
        update: "Update",
        cancel: "Cancel",
        none: "No action",
      },
      edit: {
        modalTitle: "Update Leave",
        required: "Please fill in all required fields: Leave Type, Start Date, Description.",
        timeRequired: "Start and end time are required for hourly leaves.",
        endDateRequired: "End date is required for daily leaves.",
        authError: "Authentication error. Please sign in again.",
        startTimeAfter: "Start time cannot be after end time.",
        hoursPositive: "Calculated duration (hours) must be a positive value.",
        startAfterEnd: "Start date cannot be after end date.",
        businessDaysPositive: "Calculated leave duration must be a positive business day count.",
        updateSuccess: "Leave updated successfully!",
        resubmittedSuccess: "Leave updated and sent for approval again.",
        updateErrorPrefix: "Failed to update leave: ",
      },
      form: {
        leaveType: "Leave Type",
        leaveTypeSelect: "Select leave type",
        subType: "Excuse leave sub-type",
        select: "Select",
        startDate: "Start Date",
        endDate: "End Date",
        startTime: "Start Time",
        endTime: "End Time",
        reason: "Description",
        reasonPlaceholder: "Enter a description for your leave...",
        reportPdfLabel: "Report (PDF) - optional",
        reportPdfLabelShort: "Report PDF",
        reportPdfHint: "Optionally upload your report as a PDF.",
        reportPdfSelected: "Selected file",
        reportPdfOnlyPdf: "Please upload a PDF file only.",
        reportPdfTooLarge: "PDF must be at most 10MB.",
        reportPdfUploadFailed: "Report PDF upload failed.",
        submit: "Submit Leave Request",
        calculating: "Calculating...",
        publicHolidays: "Public holidays",
        publicHolidaysNotice: "These days are not deducted from leave balance.",
        back: "Back",
        next: "Next",
        confirm: "Confirm and submit",
        steps: {
          type: "Leave type",
          date: "Dates",
          reason: "Description",
          review: "Review",
        },
        errors: {
          requiredFields: "Please fill in all required fields.",
          genderFetchFailed: "Failed to fetch user gender.",
          loadFailed: "Failed to load required data.",
          subTypeRequired: "Selecting a sub-type is required for excuse leave.",
          timeRequired: "Please select start and end times.",
          endDateRequired: "End date is required.",
          hourlyLimit: "Hourly duration must be > 0 and cannot exceed {{max}}.",
        },
        warnings: {
          startTimeMin: "Start time cannot be earlier than 08:00.",
          endTimeMax: "End time cannot be later than 18:00.",
          timeRangeInvalid:
            "Selected time range (after subtracting lunch break) cannot be zero or negative. Please choose another range.",
          maxDuration: "Duration cannot exceed {{max}}. Selected: {{selected}}",
        },
      },
      summary: {
        title: "Leave Summary",
        annualTitle: "Annual Leave Summary",
        unpaidTitle: "Unpaid Leave Summary",
        travelTitle: "Business Travel Summary",
        hourlyTitle: "Hourly Leave Summary",
        excuseTitle: "Excuse Leave Summary",
        currentAnnualBalance: "Current annual leave balance",
        requestedDuration: "Requested duration",
        returnTime: "Return to work time",
        returnDate: "Return to work date",
        remainingAfter: "Remaining balance after leave",
        businessDays: "business days",
        hours: "hours",
        days: "days",
      },
      document: {
        ref: "Document Ref",
        download: "Download (PDF)",
        downloadShort: "PDF",
        previewShort: "Preview",
        openNewTab: "Open tab",
      },
      reportPdf: {
        title: "Report PDF",
        badge: "Report",
        previewShort: "Preview report",
        downloadShort: "Download report",
      },
      status: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        skipped: "Skipped",
        cancelled: "Cancelled",
      },
    },
    admin: {
      dashboard: {
        title: "Admin Panel",
        statsTitle: "Overall Leave Statistics",
        pendingTitle: "Pending Approvals",
        pendingEmpty: "There are no leave requests pending approval.",
      },
      users: {
        title: "Users",
        newUser: "New User",
        deleteConfirm: "Delete this user?",
        active: "Active",
        totalLeave: "Remaining leave",
	        totalLeaveDays: "Remaining leave (days)",
	        import: {
	          title: "Bulk Add Users (Excel .xlsx)",
	          downloadTemplate: "Download sample Excel (.xlsx)",
	          exportButton: "Export users (.xlsx)",
	          chooseFile: "Choose file",
	          importButton: "Import",
	          help: "Upload an Excel (.xlsx) file. First row must be headers.",
	          resultTitle: "Import result",
	          created: "Created",
	          skipped: "Skipped",
	          failed: "Failed",
	          warnings: "Warnings",
	          passwordNote: "If password is empty, system generates it and shows only on this screen.",
	        },
        fields: {
          name: "First name",
          surname: "Last name",
          email: "Email",
          username: "Username",
          role: "Role",
          team: "Team",
          manager: "Unit supervisor",
          department: "Department",
          section: "Section",
          title: "Title",
          gender: "Gender",
          registryNumber: "Registry No",
          birthDate: "Birth date",
          leaveBaseDate: "Hire date",
          leaveAccrualStartDate: "Next accrual date",
          nextAccrualEntitlementDays: "Next accrual (days)",
          password: "Password",
          passwordOptional: "Password (optional)",
        },
        editTitle: "Edit user: {{username}}",
      },
      teams: {
        title: "Teams",
        namePlaceholder: "Team name",
        managerPlaceholder: "(Select team manager)",
        add: "Add",
        deleteConfirm: "Delete this team?",
        columns: { name: "Name", manager: "Manager" },
      },
      leaves: {
        title: "Leave Requests",
        empty: "There are no leave requests to display yet.",
        approve: "Approve",
        reject: "Reject",
        requestEdit: "Request edit",
        sendEditRequest: "Send request",
        approveEdit: "Approve edit",
        rejectEdit: "Reject edit",
        editRequested: "Edit request sent to company manager approval.",
        editApproved: "Edit approved and applied.",
        editRejected: "Edit request rejected.",
        noAction: "No action",
        columns: {
          requester: "Employee",
          type: "Leave type",
          duration: "Duration",
          actions: "Actions",
        },
        start: "Start",
        end: "End",
        balance: "Balance",
        balanceNotAffected: "Does not affect balance",
        missingInfo: "Missing info",
        loadErrorPrefix: "Failed to load leaves: ",
        updateErrorPrefix: "Failed to update leave status: ",
        rejectPrompt: "Rejection reason (optional)",
        rejectTitle: "Reject leave request",
        hrCancel: "Cancel Leave",
        hrCancelTitle: "Cancel Approved Leave",
        hrCancelIntro:
          "You are about to cancel {{person}}'s {{type}} leave ({{start}} → {{end}}).",
        hrCancelRestoreBalance: "Restore the deducted balance to the user",
        hrCancelReasonLabel: "Cancellation reason (optional)",
        hrCancelReasonPlaceholder: "Reason…",
        hrCancelConfirm: "Cancel it",
        hrCancelSuccess: "Leave cancelled.",
        hrCancelSuccessRestored: "Leave cancelled and balance restored.",
        code: "Code",
        balanceBefore: "Before",
        balanceAfter: "After",
        createdAt: "Created",
        details: "Details",
        detailsTitle: "Leave Details",
        notLoaded: "Failed to load details.",
        sectionRequester: "Requester",
        sectionLeave: "Leave Info",
        sectionApproval: "Approval Flow",
        sectionTravel: "Mission / Travel Details",
        sectionPerDiem: "Per Diem",
        sectionExpenses: "Extra Expenses",
        proxyUser: "Proxy user",
        reasonLabel: "Reason",
        excuseLabel: "Excuse Detail",
        travelDestination: "Destination",
        travelProject: "Project",
        travelDays: "Mission days",
        documentationUrl: "Document link",
        tripType: "Trip type",
        tabs: { mine: "My turn", pending: "Pending", approved: "Approved", closed: "Rejected / Cancelled", all: "All" },
        filters: {
          search: "Search name or request code...",
          allTypes: "All leave types",
          from: "Start ≥",
          to: "End ≤",
          sort: "Sort",
          sortCreatedDesc: "Requested (newest first)",
          sortCreatedAsc: "Requested (oldest first)",
          sortStartAsc: "Leave start (soonest first)",
          sortStartDesc: "Leave start (latest first)",
          reset: "Clear filters",
        },
        emptyFiltered: "No records in this view.",
        approvalChain: "Approval chain",
        waitingDays: "days waiting",
        tripDomestic: "Domestic",
        tripInternational: "International",
        tripIntracity: "Intra-city (no per diem)",
        transport: "Transport",
        accommodation: "Accommodation",
        perDiemDaily: "Daily per diem",
        perDiemDays: "Days",
        perDiemTotal: "Total per diem",
        perDiemSave: "Save",
        perDiemSaving: "Saving…",
        perDiemUpdated: "Per diem amount updated.",
        perDiemUpdateFailed: "Could not update per diem amount.",
        perDiemInvalid: "Daily per diem amount is invalid.",
        expensePayee: "Payee",
        expenseDate: "Date",
        expenseInvoice: "Invoice amount",
        expenseLimit: "Limit",
        expensePayable: "Payable",
        expenseDescription: "Description",
        expenseReceipt: "Receipt",
        expenseReceiptYes: "Uploaded",
        expenseReceiptNo: "Missing",
        expenseReceiptUpload: "Upload",
        expenseReceiptReplace: "Replace",
        expenseReceiptDownload: "Download",
        expenseReceiptUploading: "Uploading…",
        expenseReceiptOnlyPdf: "Please upload a PDF only.",
        expenseReceiptTooLarge: "PDF file must be at most 10MB.",
        expenseReceiptUploaded: "Receipt uploaded.",
        expenseReceiptUploadFailed: "Receipt upload failed.",
        expenseReceiptDownloadFailed: "Receipt download failed.",
      },
      siteActivities: {
        title: "Site Activity",
        subtitle: "Review and filter user and system actions from the last 6 months.",
        empty: "No activity found for the selected filters.",
        filters: {
          from: "From",
          to: "To",
          user: "User",
          action: "Action",
          entity: "Record type",
          outcome: "Outcome",
          search: "Search",
          searchPlaceholder: "Search user, action or path",
          allUsers: "All users",
          allActions: "All actions",
          allEntities: "All record types",
          allOutcomes: "All outcomes",
          apply: "Apply filters",
          reset: "Reset to default 7 days",
        },
        columns: {
          date: "Date",
          user: "User",
          action: "Action",
          entity: "Record",
          detail: "Detail",
          outcome: "Outcome",
        },
      },
    },
    team: {
      eyebrow: "Team roster",
      title: "My Team",
      subtitle: "See your direct reports and their basic info.",
      refresh: "Refresh",
      empty: "No direct reports found.",
      calendarTitle: "Leave calendar",
      calendarScopeCompany: "Approved leaves across the company",
      calendarScopeUnit: "Approved leaves in my unit",
      calendarApprovedLegend: "Approved leave",
      calendarOffCount: "{{count}} people off",
      upcomingApprovedTitle: "Upcoming approved leaves",
      upcomingInDays: "Starts in",
      inDays: "{{days}} days",
      columns: {
        name: "Full name",
        username: "Username",
        role: "Role",
        team: "Team",
        department: "Department/Section",
        manager: "Manager",
        annualLeaveBalance: "Annual Leave Balance",
      },
      roles: {
        companyManager: "Company Manager",
        hr: "HR",
        unitSupervisor: "Unit Supervisor",
        employee: "Employee",
        it: "IT",
      },
    },
    teamLeaves: {
      eyebrow: "Team leave history",
      title: "Team Leaves",
      subtitle: "Review your team’s leave history and current status.",
      refresh: "Refresh",
      export: "Download history",
      filters: {
        user: "Employee",
        status: "Status",
        allUsers: "All people",
        allStatuses: "All statuses",
        includeRejected: "Include rejected",
      },
      columns: {
        person: "Employee",
        username: "Username",
        team: "Team",
        type: "Leave",
        start: "Start",
        end: "End",
        duration: "Duration",
        status: "Status",
        stage: "Stage",
      },
      empty: "No leaves to show.",
    },
    leaveTypes: {
      title: "Leave Types",
      loadError: "Failed to load leave types.",
      empty: "No leave types defined yet.",
      newType: "New leave type",
      editType: "Edit leave type",
      confirmDelete: "Delete this leave type?",
      defaultQuotaDays: "Default quota (days)",
      defaultQuotaHours: "Default quota (hours)",
      columns: {
        name: "Name",
        description: "Description",
        affectsBalance: "Affects Balance",
        type: "Type",
        defaultDuration: "Default Duration",
      },
      duration: {
        hourly: "Hourly",
        daily: "Daily",
      },
    },
    satRequest: {
      title: "Purchase Requests",
      subtitle: "Create and track procurement requests.",
      newRequest: "New Request",
      fields: {
        code: "Request Code",
        title: "Title",
        description: "Description",
        category: "Category",
        priority: "Priority",
        itemUrl: "Item Link",
        itemUrlPlaceholder: "https://...",
        quantity: "Quantity",
        unitPrice: "Unit Price (TRY)",
        totalPrice: "Total",
        needsItReview: "Have IT review product alternatives",
        needsItReviewHint:
          "If checked, the request goes through IT review after supervisor approval. Otherwise the IT step is skipped.",
        createdBy: "Requester",
        assignee: "Assigned IT",
        createdAt: "Created",
        status: "Status",
        note: "Note",
        notePlaceholder: "Optional note",
        reason: "Reject Reason",
        reasonPlaceholder: "Reason for rejection (min 10 chars)",
        invoiceUrl: "Invoice Link",
        invoiceUrlPlaceholder: "https://... (receipt/invoice PDF or image)",
        invoiceFile: "Invoice File",
        actualPrice: "Actual Unit Price (TRY)",
        actualTotal: "Actual Total",
        department: "Department",
        total: "Total",
      },
      category: {
        unit_need: "Unit / Business Need",
        it_need: "IT Need",
        office_supplies: "Office Supplies",
        general_supplies: "General Supplies",
        // legacy
        hardware: "Hardware",
        software: "Software",
        access: "Access / License",
        other: "Other",
      },
      priority: {
        low: "Low",
        medium: "Medium",
        high: "High",
      },
      status: {
        pending_supervisor: "Awaiting Supervisor",
        pending_it: "Awaiting IT Review",
        pending_manager: "Awaiting Manager",
        pending_hr: "Awaiting HR",
        completed: "Completed",
        rejected: "Rejected",
        cancelled: "Cancelled",
      },
      actions: {
        supervisorApprove: "Supervisor Approve",
        supervisorReject: "Supervisor Reject",
        itApprove: "IT Approve",
        itReject: "IT Reject",
        managerApprove: "Manager Approve",
        managerReject: "Manager Reject",
        hrComplete: "HR Complete",
        hrReject: "HR Reject",
        cancel: "Cancel",
      },
      tabs: {
        supervisor: "Supervisor",
        it: "IT Review",
        manager: "Manager",
        hr: "HR",
        completed: "Completed",
        all: "All",
      },
      empty: "No requests yet.",
      myEmpty: "You have not created any requests yet.",
      timeline: {
        created: "Request created",
        supervisor_approved: "Supervisor approved",
        supervisor_rejected: "Supervisor rejected",
        it_edited: "IT edited request fields",
        it_approved: "IT approved",
        it_rejected: "IT rejected",
        manager_approved: "Manager approved",
        manager_rejected: "Manager rejected",
        hr_rejected: "HR rejected",
        completed: "HR completed",
        cancelled: "Cancelled",
        claimed: "Claimed",
        released: "Released",
        proforma_uploaded: "Order quote uploaded",
        invoice_uploaded: "Invoice uploaded",
      },
      docs: {
        title: "Documents (can be added at any stage)",
        proforma: "Order quote (PDF/JPG/PNG)",
        invoice: "Invoice (PDF/JPG/PNG)",
        hint: "Optional. Uploading a new file replaces the previous one (max 10MB).",
      },
      confirmCancel: "Cancel this request?",
      confirmRelease: "Release request back to the pool?",
      validation: {
        titleLen: "Title must be 3-200 characters.",
        descriptionLen: "Description must be at least 10 characters.",
        urlInvalid: "Please enter a valid http/https link.",
        quantityMin: "Quantity must be at least 1.",
        unitPriceMin: "Unit price must be 0 or greater.",
        invoiceUrlInvalid: "Please enter a valid http/https invoice link.",
        fileRequired: "Please choose an invoice file.",
        fileTooLarge: "File size must be 10 MB or less.",
        actualPriceMin: "Actual price must be 0 or greater.",
      },
      completeModal: {
        title: "Complete Request",
        hint: "Enter invoice link and actual unit price. The plan vs. actual difference will be tracked.",
      },
      exportXlsx: "Export Excel",
      departmentReport: "Department Report",
      teamReport: "Team Report",
      groupBy: "Group by",
      groupByDepartment: "Department",
      groupByTeam: "Team",
      teamLabel: "Team",
      teamUnknown: "(no team)",
      dateFrom: "From",
      dateTo: "To",
      apply: "Apply",
      clear: "Clear",
      proformaFile: "Quote / Proforma File",
      proformaFileHint: "Optional: PDF, JPG or PNG (max 10MB).",
      proformaDownload: "Download quote / proforma",
      invoiceDownload: "Download invoice",
      noProforma: "No quote / proforma uploaded.",
      itemUrlOptionalHint: "Item link is optional; you may leave it blank if you upload a quote/proforma.",
      widget: {
        myOpen: "My open requests",
        awaitingSupervisor: "Supervisor approval",
        awaitingIt: "IT review",
        awaitingManager: "Manager approval",
        awaitingHr: "HR completion",
      },
    },
  },
};
